import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=c47aedfa&scoped=true&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=c47aedfa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47aedfa",
  null
  
)

export default component.exports